var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "activity-stage"
  }, [_c('div', [_c('figure', [_vm.currentStep.img ? _c('img', {
    attrs: {
      "src": _vm.currentStep.img,
      "alt": _vm.currentStep.answer
    }
  }) : _vm._e()]), _c('div', {
    attrs: {
      "id": "steps"
    }
  }, _vm._l(_vm.currentRound.steps, function (step) {
    return _c('text-display-list', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: step.stepIndex <= _vm.progress.stepIndex,
        expression: "step.stepIndex <= progress.stepIndex"
      }],
      key: step.stepIndex,
      attrs: {
        "id": "input",
        "text-size": "small"
      }
    }, [_c('color-block-text', {
      attrs: {
        "text": step.answer,
        "text-step": step.stepIndex
      }
    })], 1);
  }), 1)]), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }